module.exports = __webpack_public_path__ + "static/media/RecruitmentR.9c450781.png";